<script lang="ts" setup>
import { useAlertStore } from '@/store/AlertStore'
import { computed, nextTick, ref, useTemplateRef, watch } from 'vue'
import Modal from '../player/Modal.vue'

const alertStore = useAlertStore()
const btn = useTemplateRef("btn")

const currentMessage = computed(() => alertStore.currentMessage)

function label(buttonType: "ok" | "cancel"): string {
	if (currentMessage.value && currentMessage.value[buttonType]?.label) {
		return currentMessage.value[buttonType]!.label!
	}
	return ""
}

function onClick(buttonType: "ok" | "cancel") {
	const msg = currentMessage.value?.[buttonType]
	if (msg && msg.handler) {
		msg.handler()
	}
	alertStore.popMessage()
}

watch(currentMessage, (message) => {
	if (message) {
		nextTick(() => {
			if (btn.value)
				btn.value.focus()
		})
	}
})
</script>


<template>
	<Modal :show="currentMessage != undefined" :closeable="!currentMessage?.cancel" @close="onClick('ok')">
		{{ currentMessage?.message }}
		<div class="alert-bottom">
			<button class="brand mr-4" @click="onClick('ok')" ref="btn">{{ label('ok') || "OK" }}</button>
			<button class="brand secondary alert-bottom" @click="onClick('cancel')" ref="btn" v-if="currentMessage?.cancel">{{
				label('cancel') || "Cancel" }}</button>
		</div>
	</Modal>
</template>

<style></style>